export const ACTION_TYPES = {
    CLICK: 'click',
    DBL_CLICK: 'dblClick',
    MOUSE_IN: 'mouseenter',
    MOUSE_OUT: 'mouseleave',
    CHANGE: 'change',
    BLUR: 'blur',
    FOCUS: 'focus',
    IMAGE_CHANGED: 'imageChanged',
    IMAGE_EXPANDED: 'imageExpanded',
    ON_INPUT: 'onInput',
    ITEM_CLICKED: 'itemClicked',
    CELL_SELECT: 'cellSelect',
    CELL_EDIT: 'cellEdit',
    ROW_SELECT: 'rowSelect',
    FETCH_DATA: 'fetchData',
    DATA_CHANGE: 'dataChange',
    ON_TIMEOUT: 'onTimeout',
    ON_VERIFY: 'onVerified',
    ON_ERROR: 'onError',
    ON_PLAY: 'onPlay',
    ON_PAUSE: 'onPause',
    ON_PROGRESS: 'onProgress',
    ON_ENDED: 'onEnded',
    AUTOPLAY_OFF: 'autoplayOff',
    AUTOPLAY_ON: 'autoplayOn',
    PLAY_ENDED: 'playEnded',
    PLAY_PROGRESS: 'playProgress',
    KEY_PRESS: 'keyPress',
    SCREEN_IN: 'screenIn',
    VIEWPORT_ENTER: 'viewportEnter',
    VIEWPORT_LEAVE: 'viewportLeave',
    SCROLL: 'scroll',
    VALIDATE: 'validate',
    SET_CUSTOM_VALIDITY: 'setCustomValidity',
    SYNC_VALIDATION_DATA: 'syncValidationData',
    UPDATE_VALIDITY_INDICATION: 'updateValidityIndication',
    MESSAGE: 'message',
    UPLOAD_COMPLETE: 'uploadComplete',
    ITEM_READY: 'itemReady',
    ITEM_REMOVED: 'itemRemoved',
    TAG_CLICK: 'tagClick',
    QUICK_ACTION_BAR_ITEM_CLICKED: 'quickActionBarItemClicked',
    GOOGLE_MAP_MARKER_CLICKED: 'markerClicked',
    GOOGLE_MAP_CLICKED: 'mapClicked',
    ICON_MOUSE_IN: 'iconMouseIn',
    DATASET_READY: 'datasetReady',
    AFTER_SAVE: 'afterSave',
    CURRENT_INDEX_CHANGED: 'currentIndexChanged',
    DATASET_ERROR: 'datasetError',
    ITEM_VALUES_CHANGED: 'itemValuesChanged',
    ON_STATE_CHANGE: 'onStateChange',
};
//# sourceMappingURL=actionTypes.js.map